export default __webpack_public_path__ + "static/media/Autoki.f7dcaaa8.png";